// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dc--btn-tertiary {
  border: solid 1px var(--text-color-secondary);
  color: var(--text-color-secondary);
  border-radius: 5px;
  padding: 0.8rem;
}

.avatar {
  width: 4rem;
  height: 4rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.avatar span {
  font-size: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/app/main/apps/components/image-selector/image-selector.component.scss"],"names":[],"mappings":"AAEA;EACI,6CAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AADJ;;AAIA;EACI,eAAA;AADJ","sourcesContent":[".btn-load {}\n\n.dc--btn-tertiary {\n    border: solid 1px var(--text-color-secondary);\n    color: var(--text-color-secondary);\n    border-radius: 5px;\n    padding: 0.80rem;\n}\n\n.avatar {\n    width: 4rem;\n    height: 4rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 6px;\n}\n\n.avatar img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.avatar span {\n    font-size: 2rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
